<button class="pm-view-options-button" mat-icon-button [matMenuTriggerFor]="viewOptionsMenu" matTooltip="{{'menu.view-options' | translate}}">
  <mat-icon>visibility</mat-icon>
</button>

<mat-menu #viewOptionsMenu="matMenu">
  <button mat-menu-item (click)="openLabelsDialog()">
    <mat-icon>label</mat-icon> {{'menu.view-options.labels' | translate}}...
  </button>
  <button mat-menu-item [matMenuTriggerFor]="highlightMenu">
    @switch (translationHighlight) {
      @case ('untranslated') {
        <mat-icon>flashlight_on</mat-icon>
      }
      @case ('translated') {
        <mat-icon class="material-symbols-unfilled">flashlight_on</mat-icon>
      }
      @case ('off') {
        <mat-icon>flashlight_off</mat-icon>
      }
    }
    {{'menu.view-options.translations' | translate}}
  </button>
  <div mat-menu-item class="menu-checkbox-wrapper" matTooltip="{{'menu.view-options.show-unsearchable.details' | translate}}">
    <mat-checkbox (click)="$event.stopPropagation()" [checked]="showUnsearchable" (change)="setShowUnsearchable($event)">
      {{'menu.view-options.show-unsearchable' | translate}}
    </mat-checkbox>
  </div>

  <div mat-menu-item class="menu-checkbox-wrapper" matTooltip="{{'menu.view-options.show-back-links.details' | translate}}">
    <mat-checkbox (click)="$event.stopPropagation()" [checked]="showBackLinks" (change)="setShowBackLinks($event)">
      {{'menu.view-options.show-back-links' | translate}}
    </mat-checkbox>
  </div>

</mat-menu>

<mat-menu #highlightMenu="matMenu">
  <button mat-menu-item  (click)="highlightSelected('untranslated')"
    [matTooltipDisabled]="!isDefaultLanguage"
    matTooltip="{{'menu.translate.highlight-untranslated.details' | translate}}">
    <mat-icon>flashlight_on</mat-icon>
    {{'menu.translate.highlight-untranslated' | translate}}
  </button>
  <button mat-menu-item  (click)="highlightSelected('translated')"
    [matTooltipDisabled]="!isDefaultLanguage"
    matTooltip="{{'menu.translate.highlight-translated.details' | translate}}">
    <mat-icon class="material-symbols-unfilled">flashlight_on</mat-icon>
    {{'menu.translate.highlight-translated' | translate}}
  </button>
  <button mat-menu-item  (click)="highlightSelected('off')">
    <mat-icon>flashlight_off</mat-icon>
    {{'menu.translate.highlight-off' | translate}}
  </button>
</mat-menu>
